import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { ComponentBase, DbaDataTableColumn, DbaMAtTableDatatypesEnum, DialogData } from '@definitiv-packages/angular-dba-library';

import {
  DebitorModel, DebitorService, ObjektModel, ObjektModelView, ObjektService, ObjektViewService, ProjectLanguage, ProjektPermissionService, RoofareaModel, RoofareaModelView, RoofareaService, RoofareaViewService, SicherungssystemModelService, SicherungssystemModelView,
  SicherungssystemViewService,
  StandortModel,
  StandortService
} from '../../../../../roofsafetymanagement-library/src/public-api';

import { CreateSicherungssystemComponent } from '../../../../../roofsafetymanagement-library/src/lib/dialogs/create-sicherungssystem/create-sicherungssystem.component';

@Component({
  selector: 'app-sicherungssystem-main-view',
  templateUrl: './sicherungssystem-main-view.component.html',
  styleUrls: ['./sicherungssystem-main-view.component.scss'],
  standalone: false
})
export class SicherungssystemMainViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public sicherungssystemList: SicherungssystemModelView[] = [];
  public selectedSicherungssystem: SicherungssystemModelView | null = null;

  public debitorList: DebitorModel[] = [];
  public selectedDebitor: DebitorModel = new DebitorModel();

  public roofareaList: RoofareaModelView[] = [];
  public roofareaFilteredList: RoofareaModelView[] = [];
  public selectedRoofarea: RoofareaModelView | null = null;

  public objektList: ObjektModelView[] = [];
  public selectedObjekt: ObjektModelView = {};
  public objektfilteredList: ObjektModelView[] = [];


  public standortList: StandortModel[] = [];
  public standortfilteredList: StandortModel[] = [];
  public selectedStandort: StandortModel = new StandortModel();

  public columnsdefMain: DbaDataTableColumn<SicherungssystemModelView, ProjectLanguage>[] = [
    { id: 'DebitorName', label: 'debitor', hideOrder: 1 },
    { id: 'StandortBezeichnung', label: 'Standort', hideOrder: 2 },
    { id: 'BezeichnungBezeichnung', label: 'objekt', hideOrder: 3 },
    { id: 'RoofareaBezeichnung', label: 'roofarea', hideOrder: 4 },
    { id: 'Bezeichnung', label: 'Bezeichnung', hideOrder: 5 }
  ];

  constructor(
    public permissionService: ProjektPermissionService,
    private sicherungssystemViewService: SicherungssystemViewService,
    private sicherungssystemService: SicherungssystemModelService,
    private objektService: ObjektViewService,
    private debitorService: DebitorService,
    private standortService: StandortService,
    private roofareaService: RoofareaViewService,
    private dialog: MatDialog,
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      var resultList = await Promise.all([
        this.sicherungssystemViewService.getFilteredList(),
        this.objektService.getFilteredList(),
        this.roofareaService.getFilteredList(),
        this.debitorService.getFilteredList({}),
        this.standortService.getFilteredList({})
      ])

      this.sicherungssystemList = resultList[0].sort((a, b) => { return (a.Bezeichnung! < b.Bezeichnung!) ? -1 : 1 });

      this.debitorList = resultList[3].sort((a, b) => { return (a.Name < b.Name) ? -1 : 1 });

      const alle: DebitorModel = new DebitorModel()
      alle.DebitorID = 0;
      alle.Name = "alle";
      this.debitorList.unshift(alle);
      this.selectedDebitor = this.debitorList[0];

      this.objektList = resultList[1].sort((a, b) => { return (a.Bezeichnung! < b.Bezeichnung!) ? -1 : 1 })
      const alle2: ObjektModelView = {
        ObjektID: 0,
        Bezeichnung: "alle"
      }
      this.objektList.unshift(alle2);
      this.objektfilteredList = this.objektList;
      this.selectedObjekt = this.objektfilteredList[0];

      this.roofareaList = resultList[2];
      const alle1: RoofareaModelView = {
        RoofareaID: 0,
        ObjektID: 0,
       
        Bezeichnung: "alle"
      }

      this.roofareaList.unshift(alle1);
      this.roofareaFilteredList = this.roofareaList;
      this.selectedRoofarea = this.roofareaFilteredList[0];

      this.standortList = resultList[4];
      const alle3: StandortModel = new StandortModel();
      alle3.StandortID = 0;
      alle3.Bezeichnung = "alle";

      this.standortList.unshift(alle3);
      this.standortfilteredList = this.standortList;
      this.selectedStandort = this.standortfilteredList[0];

    } finally {
      this.loading = false;
    }
  }

  public async OpenDialog(data: DialogData<SicherungssystemModelView>): Promise<void> {
    if (!this.permissionService.SicherungssystemLesen) return;

    var sicherungssystem = await firstValueFrom(this.dialog.open(CreateSicherungssystemComponent, { data: data }).afterClosed());

    if (!sicherungssystem)
      return

    var changedsicherungssystem = await this.sicherungssystemViewService.get(sicherungssystem.SicherungssystemID)

    this.selectedSicherungssystem = null;

    if (data.mode == 'create' || data.mode == 'copy')
      this.sicherungssystemList.push(changedsicherungssystem);
    else if (data.mode == 'edit') {
      var index = this.sicherungssystemList.findIndex(x => x.SicherungssystemID == sicherungssystem.SicherungssystemID);
      if (index != -1)
        this.sicherungssystemList[index] = changedsicherungssystem;
    }

    this.selectedSicherungssystem = changedsicherungssystem;
  }

  public objektFilter = (list: SicherungssystemModelView[], filter: ObjektModelView): SicherungssystemModelView[] => {
    if (filter.ObjektID == undefined || filter.ObjektID == 0)
      return list;
    else
      return list.filter(x => x.ObjektID == filter.ObjektID);
  }

  public debitorFilter = (list: RoofareaModelView[], filter: DebitorModel): RoofareaModelView[] => {
    if (filter.DebitorID == undefined || filter.DebitorID == 0)
      return list;
    else
      return list.filter(x => x.DebitorID == filter.DebitorID);
  }

  public standortFilter = (list: RoofareaModelView[], filter: StandortModel): RoofareaModelView[] => {
    if (filter.StandortID == undefined || filter.StandortID == 0)
      return list;
    else
      return list.filter(x => x.StandortID == filter.StandortID);
  }

  public roofareaFilter = (list: SicherungssystemModelView[], filter: RoofareaModelView): SicherungssystemModelView[] => {
    if (filter.RoofareaID == undefined || filter.RoofareaID == 0)
      return list;
    else
      return list.filter(x => x.RoofareaID == filter.RoofareaID);
  }

  public async deleteData(sicherungssystemID: number): Promise<void> {
    this.loading = true;
    await this.sicherungssystemService.delete(sicherungssystemID);
    this.sicherungssystemList = await this.sicherungssystemViewService.getList();
    this.loading = false;
  }


  public filterStandort() {

    if (this.selectedDebitor?.DebitorID == 0) {
      this.standortfilteredList = this.standortList;
    }
    else {
      this.standortfilteredList = this.standortList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.DebitorID == 0)
    }
    this.selectedStandort = this.standortfilteredList[0];
    this.filterObjekte();
  }

  public filterObjekte() {

    this.objektfilteredList = this.objektList;
    if (this.selectedDebitor?.DebitorID) {

      this.objektfilteredList = this.objektfilteredList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.ObjektID == 0)
    }
    if (this.selectedStandort?.StandortID) {
      this.objektfilteredList = this.objektfilteredList.filter(x => x.StandortID == this.selectedStandort?.StandortID || x.ObjektID == 0)
    }
    this.selectedObjekt = this.objektfilteredList[0];
    this.filterroofarea();
  }

  public filterroofarea() {

    this.roofareaFilteredList = this.roofareaList;
    if (this.selectedDebitor?.DebitorID) {

      this.roofareaFilteredList = this.roofareaFilteredList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.RoofareaID == 0)
    }
    if (this.selectedStandort?.StandortID) {
      this.roofareaFilteredList = this.roofareaFilteredList.filter(x => x.StandortID == this.selectedStandort?.StandortID || x.RoofareaID == 0)
    }
    if (this.selectedObjekt?.ObjektID) {
      this.roofareaFilteredList = this.roofareaFilteredList.filter(x => x.ObjektID == this.selectedObjekt?.ObjektID || x.RoofareaID == 0)
    }
    this.selectedRoofarea = this.roofareaFilteredList[0];
  }
}
